// AUTHOR: ELI RICKARD (2024)
// SITEWIDE FIXES & LOGIC
// Reffed in footer.liquid
console.log("ECORE by Eli Rickard (Loaded)")

const currentUrl = window.location.href;

const links = document.querySelectorAll('.header__primary-nav-item a');


links.forEach(link => {

  if (currentUrl.endsWith(link.getAttribute('href'))) {

    const listItem = link.closest('li');
      listItem.style.color = "#f5a2e0"
  }
});

// FORCED LANGUAGE CHANGES

document.addEventListener('DOMContentLoaded', function() {
            reSpan()
        });

function reSpan() {
            const spans = document.querySelectorAll('span');

            // Loop through each span and check its style properties
            spans.forEach(span => {
                const style = window.getComputedStyle(span);
                if (
                    style.fontStyle === 'normal' &&
                    style.fontWeight === '400' &&
                    style.fontSize === '12px' &&
                    style.lineHeight === '18px' &&
                    style.whiteSpace === 'nowrap' &&
                    span.textContent.trim() === 'Verified'
                ) {
                    span.textContent = 'Verified Buyer';
                }
            });
}






